<template>
  <article class="flex h-screen w-full">
    <section class="w-full sm:w-6/12 px-8 md:px-12 py-8 flex flex-col">
      <div class="flex-none">
        <div
          class="text-2xl font-bold text-primary leading-9 tracking-tight"
          alt="Meridia verify"
        >
          Meridia Verify
        </div>
      </div>
      <div class="flex-1 flex items-center">
        <div class="w-full max-w-[400px]">
          <MeridiaIcon
            name="warning"
            type="material-symbols-outlined"
            class="text-critical-surface-default mb-l"
            style="font-size: 40px"
          />

          <h2
            data-testid="error-title"
            class="mb-xl text-heading-large text-critical-surface-default"
          >
            {{ title }}
          </h2>
          <p
            data-testid="error-sub"
            class="text-title-small text-neutral-text-subtitle"
          >
            {{ subtitle }}
          </p>

          <!-- Show detailed error message if available -->
          <div
            v-if="errorDetails?.message"
            class="mt-xl"
            data-testid="error-message"
          >
            <p class="text-body-base text-neutral-text-disabled">
              {{ errorDetails.message }}
            </p>
          </div>

          <MeridiaButton
            data-testid="reload-cta"
            :label="$t('fatal_error.retry')"
            @click="handleRetry"
            type="primary"
            size="base"
            class="mt-m"
          />
        </div>
      </div>
      <FooterComponent class="flex-none" />
    </section>
    <LoginImage />
  </article>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useAppStore } from 'src/core/stores/app';
import FooterComponent from 'src/core/components/FooterComponent.vue';
import LoginImage from 'src/modules/login/components/LoginImage.vue';
import MeridiaButton from 'src/design_system/components/button/MeridiaButton.vue';
import MeridiaIcon from 'src/design_system/components/icon/MeridiaIcon.vue';

const props = defineProps<{
  title: string;
  subtitle: string;
  errorDetails?: {
    message: string;
    type: string;
  };
}>();

const router = useRouter();
const appStore = useAppStore();

function handleRetry() {
  // Clear the error state
  appStore.errorDetails = undefined;

  // restart the app
  if (props.errorDetails?.type === 'INITIALIZATION_ERROR') {
    window.location.href = '/';
  } else if (router.options?.history?.state?.back) {
    // Try to go back to the previous route
    router.push(String(router.options.history.state.back));
  } else {
    // If no previous route, go to home
    router.push('/');
  }
}
</script>
